import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getCompareCompetitorsKeyMetrics: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  const obj: any = {
    url: `${prefix}/compare/key_metrics`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<overviewOriginType>;
};

export const getCompareCompetitorsTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  const obj: any = {
    url: `${prefix}/compare/timeline`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<overviewOriginType>;
};

export const getCompareCompetitorsGrouping: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  const obj: any = {
    url: `${prefix}/compare/grouping`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<overviewOriginType>;
};

export const getCompareChannelShareRanking: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  const obj: any = {
    url: `${prefix}/compare/channel_share_ranking`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<any>;
};

export const getCompareTrendTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  const obj: any = {
    url: `${prefix}/compare/channel_share_ranking_timeline`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<any>;
};

export const getCompareHashtagMultiTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  const obj: any = {
    url: `${prefix}/hashtag/multi_timelines`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<any>;
};

export const getLevelUpGameList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  const obj: any = {
    url: `${prefix}/game_list`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<any>;
};

export const getCompareChannelShareRankingDownload: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  const obj: any = {
    url: `${prefix}/compare/channel_share_ranking_download`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelTokenFunc === 'function') {
    obj.cancelToken = new CancelToken(cancelTokenFunc);
  }
  return http(obj) as Promise<any>;
};
